import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import AccountBlockedComponent from '../AccountBlockedComponent/AccountBlockedComponent';

class AccountBlockedPageComponent extends Component {
    render() {
        const {lingua} = this.props;
        let cardContent = (
            <AccountBlockedComponent lingua={lingua}/>
        );
        return (
            <div className="AccountBlockedPageComponent border-border-color">
                <HeaderSectionComponent title={lingua.read('lex.header.blocked')} />
                <CalloutCardComponent content={cardContent} />
                <TandCComponent lingua={lingua} />
            </div>
        );
    }
}

export default AccountBlockedPageComponent;
